import _setHelpers from "../internals/set-helpers";
var exports = {};
var has = _setHelpers.has;

// Perform ? RequireInternalSlot(M, [[SetData]])
exports = function (it) {
  has(it);
  return it;
};
export default exports;